import React from 'react'
import styles from './Breadcrumb.module.scss'

const Breadcrumb = ({ paths }) => {
  return (
    <nav aria-label="breadcrumb" className={styles.breadcrumb}>
      <ul className={styles.breadcrumb_list}>
        {paths.map(({ name, url }, index) => {
          const isLast = index === paths.length - 1

          return (
            <li key={name} className={styles.breaditem}>
              {name === 'Services' ? (
                <>
                  <span className={styles.none}>{name}</span>
                  <svg
                      className={styles.breaditem_svg}
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="chevron">
                        <path
                          id="Vector"
                          d="M4.14656 3.55754L6.43656 5.85254L4.14656 8.14754L4.85156 8.85254L7.85156 5.85254L4.85156 2.85254L4.14656 3.55754Z"
                          fill="currentColor"
                        />
                      </g>
                    </svg>
                  </>
              ) : isLast ? (
                <span className={styles.last}>{name}</span>
              ) : (
                <>
                  <a href={url}>{name}</a>
                  <svg
                    className={styles.breaditem_svg}
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="chevron">
                      <path
                        id="Vector"
                        d="M4.14656 3.55754L6.43656 5.85254L4.14656 8.14754L4.85156 8.85254L7.85156 5.85254L4.85156 2.85254L4.14656 3.55754Z"
                        fill="currentColor"
                      />
                    </g>
                  </svg>
                </>
              )}
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Breadcrumb
